import React from 'react';
import { Company } from '@/lib/types';

interface CompanyLinksProps {
  company: Company | null;
  companyName: string;
}

const CompanyLinks: React.FC<CompanyLinksProps> = ({ company, companyName }) => {
  if (!company) return null;
  
  return (
    <div className="mb-4">
      {/* Social media links have been moved to CompanyBio component */}
    </div>
  );
};

export default CompanyLinks;
